
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/asia-cup-2025/[slug]/info",
      function () {
        return require("private-next-pages/sports/asia-cup-2025/[slug]/info/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/asia-cup-2025/[slug]/info"])
      });
    }
  